import { render, staticRenderFns } from "./examinationpaper.vue?vue&type=template&id=a6ce9ee4&scoped=true&"
import script from "./examinationpaper.vue?vue&type=script&lang=js&"
export * from "./examinationpaper.vue?vue&type=script&lang=js&"
import style0 from "./examinationpaper.vue?vue&type=style&index=0&id=a6ce9ee4&prod&lang=css&"
import style1 from "./examinationpaper.vue?vue&type=style&index=1&id=a6ce9ee4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ce9ee4",
  null
  
)

export default component.exports